const siteName = "Sage Creations"

const onProduction = true

const baseUrl = onProduction ? 'https://sagecreations.co.ke' : 'http://127.0.0.1:8000'

const multipartHeader = { "Content-Type": "multipart/form-data" }

const toastError = "Something Went Wrong"

const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const makeProfileLetter = (user) => {
    const mail = user?.email
    if (!mail) {
        return 'S'
    }
    const letter = mail.charAt(0)
    return letter.toUpperCase()
}
const toasterPosition = "bottom-center"

const toasterOptions = {
    className: "rounded-md border"
}

const errorMsg = "Something Went Wrong"

const api = "/api/v1"


const utils = {
    siteName,
    multipartHeader,
    baseUrl,
    toCommas,
    makeProfileLetter,
    toasterPosition,
    toasterOptions,
    errorMsg,
    toastError,
    api,
}


export default utils